import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d66a2c9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "black-video-list-div"
};
import ads from '@/api/modules/ads';
import { useIndexStore } from '../store';
import { storeToRefs } from 'pinia';
import { onMounted, computed, ref, watch, provide } from 'vue';
import { useRoute } from 'vue-router';
import { nextTick } from 'vue';
import { judgeClient } from '@/utils';
import { channelCode } from '@/js/channel';
// const pageLoading = ref(true)

/*
黑料h5首页，增加自动下载apk和保存ios书签的功能。
条件 : 
1. 判断当前系统是安卓还是IOS跳转到对应地址， 
2. h5首页跳转到apk链接或书签地址，记录当前时间， 48小时内不再自动下载。
*/

export default {
  __name: 'home',
  setup(__props) {
    function autoDownload() {
      const appDown = () => {
        console.log('自动下载', judgeClient());
        let Android_down_url = 'https://nhyqk39hq.dsssdf06.com/download/app-hlwcmys-release.apk'; //安卓地址apk 下载地址
        let ios_down_url = 'https://app.973271.com/miaoshu/heiliao/4.mobileconfig'; // ios地址，或者 书签
        // 判断当前系统是安卓还是IOS跳转到对应地址
        if (judgeClient() === 'IOS' && !isPWA()) {
          window.location.href = ios_down_url;
        } else if (judgeClient() === 'Android') {
          window.location.href = Android_down_url;
        }
      };
      let haveTime = 48 * 60 * 60 * 1000; // 48小时 

      //haveTime = 60 * 1000;// 测试1分钟

      //判断当前时间是否存在和是否过了48小时
      if (localStorage.getItem('autoDownloadTime')) {
        let time = new Date().getTime() - localStorage.getItem('autoDownloadTime');
        if (time > haveTime) {
          // 记录当前时间， 48小时内不再自动下载
          localStorage.setItem('autoDownloadTime', new Date().getTime());
          appDown();
        }
      } else {
        // 记录当前时间， 48小时内不再自动下载
        localStorage.setItem('autoDownloadTime', new Date().getTime());
        appDown();
      }
    }

    // 公告弹窗，通过ref控制组件的方法。
    const headNav = ref();
    const route = useRoute();
    const userIndex = useIndexStore();
    const {
      allVideoList,
      allAdsList,
      categoryList
    } = storeToRefs(userIndex);
    const {
      fetchVideoList,
      fetchClassificationList,
      setCurrentVideoList,
      setCurrentVideoListParams
    } = userIndex;

    // const videoList = computed(() => {
    //   return allVideoList.value
    // })

    // 保存网址方法
    const openSaveTheUrl = ref(() => {});
    provide('openSaveTheUrl', openSaveTheUrl);
    const onImgload = () => {
      openSaveTheUrl.value();
    };
    const currentPage = ref(1);
    const goPage = ref();
    const scrollToTop = () => {
      let sTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (sTop > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, sTop - sTop / 8);
      }
    };
    const resetPage = () => {
      scrollToTop();
      videoList.value = [];
      currentPage.value = 1;
      finished.value = false;
      onLoad();
    };
    provide('resetPage', resetPage);
    const videoList = ref([]);
    const onLoad = async init => {
      const params = {
        id: route.query?.id || categoryList.value[0].id,
        type: route.query?.type || categoryList.value[0].type,
        only_topic: route.query?.only_topic || categoryList.value[0].only_topic,
        page: currentPage.value
      };
      if (init && currentPage.value === 1) return;
      const res = await fetchVideoList(params);
      loading.value = false;
      if (res.data.list.length > 0) {
        currentPage.value += 1;
        videoList.value = [...videoList.value, ...res.data.list];
        const filterVideoList = videoList.value.filter(v => v.href);
        const adsList = allAdsList.value.filter(v => v.class_id === 20);
        if (adsList.length) {
          for (let i = 1; i < filterVideoList.length; i++) {
            if (i % 3 === 2) {
              const currentIndex = videoList.value.findIndex(v => v.href === filterVideoList[i].href);
              if (!videoList.value[currentIndex + 1]?.icon) {
                videoList.value.splice(currentIndex + 1, 0, adsList[Math.floor(Math.random() * adsList.length)]);
              }
            }
          }
        }
        nextTick(() => {
          setCurrentVideoList(filterVideoList);
          setCurrentVideoListParams(params);
        });
      } else {
        finished.value = true;
      }
    };
    const loading = ref(false);
    const finished = ref(false);
    const loadCate = async () => {
      if (!categoryList.value.length) {
        await fetchClassificationList();
        onLoad();
      } else {
        fetchClassificationList();
        onLoad();
      }
    };
    watch(route, v => {
      resetPage();
    });
    onMounted(() => {
      loadCate();

      // 显示公告窗口
      headNav.value.saveTheUrl();

      // 自动下载
      // if (channelCode == 'hlwcmys') {
      //     autoDownload()
      // }
      // setTimeout(() => {
      //     autoDownload()
      // }, 2000)

      // Promise.all([loadCate(), fetchClassificationList(), setCurrentVideoList(), setCurrentVideoListParams()]).then(() => {
      //     pageLoading.value = false
      // })
    });

    return (_ctx, _cache) => {
      const _component_HeaderNav = _resolveComponent("HeaderNav");
      const _component_CommonHeaderNew = _resolveComponent("CommonHeaderNew");
      const _component_AdsPictures = _resolveComponent("AdsPictures");
      const _component_VideoList = _resolveComponent("VideoList");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(_component_HeaderNav, {
        ref_key: "headNav",
        ref: headNav
      }, null, 512), [[_vShow, false]]), _createVNode(_component_CommonHeaderNew), _createVNode(_component_AdsPictures, {
        type: 33,
        number: 1,
        random: true,
        alt: "首页banner375x135"
      }), _createVNode(_component_AdsPictures, {
        type: 34,
        number: 15,
        random: true,
        alt: "首页banner下文字链3x5"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        finished: finished.value,
        "immediate-check": false,
        "finished-text": "没有更多了",
        onLoad: _cache[1] || (_cache[1] = $event => onLoad(1))
      }, {
        default: _withCtx(() => [_createVNode(_component_VideoList, {
          list: videoList.value
        }, null, 8, ["list"])]),
        _: 1
      }, 8, ["loading", "finished"])]), _createVNode(_component_AdsPictures, {
        type: 5,
        onOnload: onImgload
      })]), _createVNode(_component_AdsPictures, {
        type: 32
      })], 64);
    };
  }
};